<template>
  <Modal
    v-model="visible"
    title="详情"
    width="800"
    :closable="false"
    :mask-closable="false"
  >
    <div style="height: 300px">
      <div>
        <Row>
          <Col span="4">用户邮箱</Col>
          <Col span="12">{{ phone }}</Col>
        </Row>
        <Row>
          <Col span="4">渠道</Col>
          <Col span="12">{{ reg_type }}</Col>
        </Row>
        <Row>
          <Col span="4">手机类型</Col>
          <Col span="12">{{ phone_type }}</Col>
        </Row>
        <Row>
          <Col span="4">年龄</Col>
          <Col span="12">{{ age }}</Col>
        </Row>
        <Row>
          <Col span="4">性别</Col>
          <Col span="12">{{ gender }}</Col>
        </Row>
        <Row>
          <Col span="4">注册日期</Col>
          <Col span="12">{{ register_time }}</Col>
        </Row>
        <Row>
          <Col span="4">最后上线日期</Col>
          <Col span="12">{{ last_login_time }}</Col>
        </Row>
        <Row>
          <Col span="4">充值金额</Col>
          <Col span="12">{{ recharge_amount }}</Col>
        </Row>
        <Row>
          <Col span="4">账户余额</Col>
          <Col span="12"
            >余币={{ coin_value }},价值={{ parseInt(coin_value) * 0.05 }}元;赏袋价值(未发货和已发货)={{ box_value??0 }}元;能量={{
              integral_value
            }}价值={{ parseInt(integral_value) / 260 }}元;勋章币数={{ coinumCost??0 }}，价值={{ parseInt(coinumCost) * 0.05 }}元;</Col
          >
        </Row>
        <Row>
          <Col span="4">净利润</Col>
          <Col span="12"
            >{{ recharge_amount - ( parseInt(coin_value) * 0.05) - ( parseInt(coinumCost ?? 0) * 0.05) - (parseInt(integral_value) / 260) - parseInt(box_value??0) }} </Col
          >
        </Row>
        <!-- <Table
            :columns="columns1"
            :data="data1"
            :scroll="{ y: 100 }"
            height="330"
          >
          </Table> -->
      </div>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right"></div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="guanbimodal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import { cmsUserInfo } from "../../api/user";

export default {
  data() {
    return {
      phone: "",
      last_login_time: "",
      recharge_amount: "",
      balance: "",
      reg_type: "",
      integral_value: "",
      box_value: "",
      coin_value: "",
      register_time: "",
      phone_type: "",
      age: "",
      gender: "",
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    user_id: {
      type: String,
      required: true,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 当模态框打开时，清空备注内容

        this.queryGoods();
      }
    },
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    guanbimodal() {
      this.$emit("guanbimodal");
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    queryGoods() {
      if (this.user_id) {
        cmsUserInfo({ user_id: this.user_id }).then((res) => {
          this.phone = res.data.user.email;
          this.register_time = res.data.user.register_time;
          this.last_login_time = res.data.usersBatch[0].loginDate;
          this.recharge_amount = res.data.userMoney.rechange_num;
          this.integral_value = res.data.userMoney.integral;
          this.box_value = res.data.stats.totalCost;
          this.coinumCost = res.data.stats2.coinumCost;
          this.coin_value = res.data.userMoney.balance;
          this.reg_type = res.data.user.reg_type == (null || undefined || "") ? "空" : res.data.user.reg_type;
          this.phone_type = res.data.user.phone_type == 0 ? "ios" : "android";
          if(res.data.user.idcard != null && res.data.user.idcard != undefined && res.data.user.idcard != "")
        {
          //通过身份证计算年龄和性别
          // this.idcard = res.data.user.idcard;
          this.age = this.calculateAge(res.data.user.idcard);
          this.gender = this.calculateGender(res.data.user.idcard);
        }
          // this.idcard = res.data.user.idcard;
          console.log(res);
        });
      }
    },
    calculateAge(idCard) {
      if (!idCard || idCard.length !== 18) return 0;
      const year = idCard.substring(6, 10);
      const month = idCard.substring(10, 12);
      const day = idCard.substring(12, 14);
      const birthDate = new Date(`${year}-${month}-${day}`);
      
      if (isNaN(birthDate.getTime())) return 0;
      
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const month_diff = today.getMonth() - birthDate.getMonth();
      
      if (month_diff < 0 || (month_diff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    calculateGender(idCard) {
      const genderCode = idCard.substring(16, 17);
      return parseInt(genderCode) % 2 === 0 ? '女' : '男';
    },
  },
};
</script>

<style scoped>
/* 添加一些样式，如果需要的话 */
</style>
